module.exports = __webpack_public_path__ + "img/mr.c94614cf.svg";